import axios from 'axios'
import { Message } from 'element-ui'

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
})

// 科室字典接口双鉴权：优先 Web 后台登录令牌（ems_web_token），未登录后台时回退小程序令牌（ems_mp_admin_token）。
// 与报修（api/repair.js）同一套写法：用请求拦截器在每次调用时动态取值，
// 后台登录后无需刷新页面即可访问科室管理页。注意：utils/request 的通用实例只带 Web Token，用它访问会 403。
api.interceptors.request.use(config => {
  const webToken = localStorage.getItem('ems_web_token')
  const mpToken = localStorage.getItem('ems_mp_admin_token')
  const token = webToken || mpToken
  if (token) {
    config.headers['Authorization'] = 'Token ' + token
  } else {
    delete config.headers['Authorization']
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    if (!status) {
      // 网络不通：请求根本没有 HTTP 响应（断网 / 超时 / DNS 失败 / 跨域被拦）
      Message.closeAll()
      Message.warning('网络无法连接后端，请检查网络或稍后重试')
    } else if (status >= 500) {
      // 服务器内部错误，与网络无关，不应误报成"未连接"
      Message.closeAll()
      Message.error('服务器异常（HTTP 500），请稍后重试或联系管理员')
    } else if (status === 403) {
      Message.error('无权限：请先登录后台账号，或在「设置令牌」中粘贴小程序后勤/管理员令牌')
    }
    return Promise.reject(error)
  }
)

export default {
  // 科室管理列表（分页）。筛选参数：keyword（名称/负责人）、include_deleted=1、page、page_size
  listDepts(params) {
    return api.get('/department/', { params })
  },
  // 新增科室：{ name, manager, location, remark }
  createDept(data) {
    return api.post('/department/', data)
  },
  // 更新科室（改名会级联同步各业务表），返回 { renamed_refs, department }
  updateDept(id, data) {
    return api.put(`/department/${id}/`, data)
  },
  // 逻辑删除科室（有在用设备时后端会 400）
  deleteDept(id) {
    return api.delete(`/department/${id}/`)
  },
  // 下拉源：全量未删除科室（不分页）
  getDeptOptions() {
    return api.get('/department/options/')
  },
  // 导出全部科室 Excel：后端 openpyxl 生成，blob 拉取（与资质 ZIP 导出同模式）
  exportExcel() {
    return api.get('/department/export/', { responseType: 'blob', timeout: 120000 })
  },
  // 查看完整联系方式（列表默认脱敏；每次查看后端记审计日志）
  revealContact(id) {
    return api.get(`/department/${id}/contact/`)
  },
  // 从设备台账导入存量科室名，返回 { imported, existed, names }
  importFromEquipment() {
    return api.post('/department/import-from-equipment/')
  },
}
